export default "__VITE_ASSET__a14da97a__"